import { Button, SimpleForm, Toolbar, useRedirect } from "react-admin";
import { FieldValues } from "react-hook-form";

import React, { useMemo, useState } from "react";
import { getRawUrlBase, PlanningResourcesEnum } from "shared/enums/resourceMappings";
import { computeDefaultValues, PlanningConfig, planningConfigurations } from "./utils";

import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import { useCallback } from "react";
import { PlanningModeEnum } from "shared/enums/globalEnums";
import { PlanningType } from "shared/types";
import TestSendingPlanningItem from "./TestSendingPlanningItem";

export interface PlanningFormProps {
  initialData: FieldValues;
}

const TestSendingForm: React.FC<PlanningFormProps> = ({ initialData }) => {
  const defaultValues = useMemo(() => computeDefaultValues(initialData), [initialData]);
  const redirect = useRedirect();
  const [isLoading, setIsLoading] = useState(false);

  const prepareData = useCallback((values: FieldValues) => {
    return Object.values(values).reduce((acc: PlanningType[], value) => {
      const { start_date, end_date, active, mode, chronicleFilename, reactivityDelay, socPercentage } = value;

      if (!active) return acc;

      const planning: PlanningType = {
        start_date,
        end_date,
        mode,
        operator_name: "",
        overidable: false,
      };

      if (mode === PlanningModeEnum.power_chronicle || mode === PlanningModeEnum.power) {
        planning.chronicle_filename = chronicleFilename;
        planning.reactivity_delay = reactivityDelay;
      } else if (mode === PlanningModeEnum.soc_management) {
        planning.target_soc = socPercentage / 100;
      }

      return [...acc, planning];
    }, []);
  }, []);

  const handleSubmit = useCallback(
    async (values: FieldValues) => {
      setIsLoading(true);
      const sitePlannings = prepareData(values);
      const preparedData = initialData.siteIds.reduce((acc: Record<number, PlanningType[]>, siteId: number) => {
        return {
          ...acc,
          [siteId]: sitePlannings,
        };
      }, {});

      try {
        const { status } = await axios({
          method: "post",
          url: `${getRawUrlBase(PlanningResourcesEnum.Plannings)}`,
          data: preparedData,
        });
        if (status >= 200 && status < 300) {
          setIsLoading(false);
          redirect(`/${PlanningResourcesEnum.Plannings}`);
        }
      } catch (error) {
        console.error("error:", error);
        setIsLoading(false);
      }
    },
    [prepareData, initialData, redirect],
  );

  return (
    <SimpleForm
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      toolbar={
        <Toolbar>
          <Button
            variant="contained"
            size="large"
            label="Submit plannings"
            disabled={isLoading}
            type="submit"
            startIcon={<SendIcon />}
          />
        </Toolbar>
      }
    >
      {planningConfigurations.map((config: PlanningConfig, index: number) => {
        return <TestSendingPlanningItem key={index} config={config} index={index} initialData={initialData} />;
      })}
    </SimpleForm>
  );
};
export default TestSendingForm;
